<div class="kPrefs kOverrideFAIcons">
  <p class="kFilterPrefs">{{ 'applications.content.filters.preferences.filterPreferences' | translate | uppercase }}</p>
  <div class="kButtons">
    <p-radioButton
      name="prefs"
      [value]="_CategoriesModes.Self"
      label="{{ 'applications.content.filters.preferences.selectedOnly' | translate }}"
      [(ngModel)]="selectionMode"
      (click)="prefChange()"
    ></p-radioButton>
    <p-radioButton
      name="prefs"
      [value]="_CategoriesModes.SelfAndChildren"
      label="{{ 'applications.content.filters.preferences.subSelected' | translate }}"
      [(ngModel)]="selectionMode"
      (click)="prefChange()"
    ></p-radioButton>
  </div>
</div>
